<template>
  <a-lazy-hydrate when-visible>
    <a-banner
      class="sidebar__banner banner-card--black"
      :wrapped-in-card="false"
      :banner-settings="$options.consts.BANNER_SETTINGS.SIDEBAR.START_TRADING"
    />
  </a-lazy-hydrate>
</template>

<script>
import ABanner from 'shared/ABanner'
import { BANNER_SETTINGS } from 'enums/banners/banner-settings'

export default {
  name: 'SidebarBannerStartTrading',
  components: {
    ABanner
  },
  consts: {
    BANNER_SETTINGS
  }
}
</script>

<style lang="scss" scoped>
.sidebar__banner {
  margin-bottom: 24px;
}
</style>
